import React from 'react'

const Social = () => {
  return (
      <div className="home__social">
        <a href="tel:+4917643822400" className="home__social-icon" target='_blank'>
            <i className="uil uil-phone"></i>
        </a>
        <a href="https://maps.app.goo.gl/JwwKd9CJM8kQMtQ87" className="home__social-icon" target='_blank'>
            <i className="uil uil-map-marker"></i>
        </a>
        <a href="mailto:tahir.waheed@conti.de" className="home__social-icon" target='_blank'>
            <i className="uil uil-envelope"></i>
        </a>
      </div>
  )
}

export default Social
